var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighlight05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Highlight_05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68796 17.7307C4.06471 17.266 2.36522 17.0316 0.716601 16.8169C0.361514 16.7718 0.0318398 17.0231 0.00647643 17.377C-0.0442503 17.7312 0.209532 18.0552 0.539255 18.1002C2.13715 18.3069 3.78561 18.5282 5.33278 18.9755C5.6625 19.0725 6.01774 18.8728 6.11919 18.5292C6.22064 18.1858 6.01769 17.828 5.68796 17.7307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6087 11.1425C7.99626 8.42288 5.05411 6.05336 2.49241 3.2608C2.26414 3 1.85833 2.98602 1.6047 3.2295C1.35106 3.47323 1.3258 3.88307 1.57943 4.14387C4.14113 6.94445 7.08328 9.32173 9.6957 12.0493C9.94934 12.3039 10.355 12.3076 10.6087 12.0571C10.837 11.8069 10.8623 11.3971 10.6087 11.1425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5036 0.68197C15.5796 2.23854 15.6556 3.7951 15.7317 5.35193C15.7317 5.70847 16.0362 5.98376 16.3913 5.96643C16.7464 5.94883 16.9998 5.64534 16.9998 5.28854C16.9238 3.72938 16.8478 2.17049 16.7717 0.611593C16.7464 0.255053 16.442 -0.0184333 16.0869 0.000972033C15.7571 0.0203774 15.4782 0.325689 15.5036 0.68197Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight05);
export default __webpack_public_path__ + "static/media/Highlight_05.cd27d9fd1e63a6cff21483488dfcb3dc.svg";
export { ForwardRef as ReactComponent };